import { yellow } from '@mui/material/colors';
import { Components, Theme } from '@mui/material/styles';

export const tabsThemeDefinition = () =>
  ({
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTab-root': {
            color: 'white',
            textTransform: 'none',
            minWidth: 'unset',
            px: 1,
          },
          '& .MuiTab-root.Mui-selected, & .MuiTabs-indicator': {
            color: yellow[500],
          },
          '& .MuiTabs-indicator': {
            backgroundColor: yellow[500],
          },
        },
      },
    },
  } as Components<Theme>);
